import {
  EventAction,
  EventAttributesActionLocation,
} from 'utils/analytics/amplitudeEventConstants';
import { ViewMode } from 'routes/authenticated/app/bookings/CalendarAndServiceRoute';
import { amplitudeSendEvent } from 'utils/analytics/amplitude';

export type SidePanelTypes =
  | 'CALENDAR_SIDE_PANEL'
  | 'TABLE_SIDE_PANEL'
  | 'FILTER_FULL_PANEL'
  | 'PARTY_SIDE_PANEL'
  | 'PARTY_FULL_PANEL'
  | 'LOCKED_FULL_PANEL'
  | 'SERVICE_TABLE_SIDE_PANEL'
  | 'WALKIN_SIDE_PANEL'
  | 'SERVICE_ASSIGN_SERVER'
  | 'SERVICE_EDIT_SERVER'
  | 'SERVICE_CREATE_SERVER'
  | 'WAITLIST_SIDE_PANEL'
  | 'WAITLIST_EDIT_SIDE_PANEL';

export enum SidePanelActionTypes {
  SIDE_PANEL_OPEN = 'SIDE_PANEL_OPEN',
  SIDE_PANEL_CLOSE = 'SIDE_PANEL_CLOSE',
}

// CRUD state in which side panel was opened
export type SidePanelCRUDAction = 'NEW' | 'EDIT';

// The button user clicked to open the side panel
export type SidePanelClickLocation =
  | 'Guest panel'
  // Following constant cannot be in sentence case because it was already been
  // created before as such in Amplitude's `EventActionLocationAttribute` type
  | 'ReservationsHeader'
  | 'Table context menu'
  | 'Table panel'
  | 'WalkIn panel';

// The section of the app where this side panel was triggered
export type SidePanelViewMode = ViewMode['mode'];

export interface SidePanelContext {
  type: SidePanelTypes;
  action?: SidePanelCRUDAction;
  viewMode?: SidePanelViewMode;
  location?: SidePanelClickLocation;
}

export interface SidePanelContextPartyFullPanel {
  type: 'PARTY_FULL_PANEL';
  /** The 'val' of the initially selected tab. */
  selectedTab?: string;
}

// payload information to pass opening context information to side panel components
export type SidePanelOpeningContext = SidePanelContext | SidePanelContextPartyFullPanel;

export interface SidePanelOpenAction {
  type: SidePanelActionTypes.SIDE_PANEL_OPEN;
  payload: SidePanelOpeningContext;
}

export interface SidePanelCloseAction {
  type: SidePanelActionTypes.SIDE_PANEL_CLOSE;
}

export type SidePanelActions = SidePanelCloseAction | SidePanelOpenAction;

export function openSidePanel(type: SidePanelTypes): SidePanelOpenAction {
  if (type === 'WAITLIST_EDIT_SIDE_PANEL') {
    amplitudeSendEvent(EventAction.WAITLIST_START_ADD_FLOW, {
      actionLocation: EventAttributesActionLocation.WAITLIST_PANEL,
    });
  }
  return {
    type: SidePanelActionTypes.SIDE_PANEL_OPEN,
    payload: { type: type },
  };
}
export function openSidePanelWithPayload(payload: SidePanelOpeningContext): SidePanelOpenAction {
  return {
    type: SidePanelActionTypes.SIDE_PANEL_OPEN,
    payload,
  };
}

export function openPartyFullPanel(selectedTab?: string): SidePanelOpenAction {
  return {
    type: SidePanelActionTypes.SIDE_PANEL_OPEN,
    payload: { type: 'PARTY_FULL_PANEL', selectedTab },
  };
}

export function closeSidePanel(): SidePanelCloseAction {
  return {
    type: SidePanelActionTypes.SIDE_PANEL_CLOSE,
  };
}
